// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionFeatureWrapperGroup_content__N_htu"};